














import DateUtil from "./shared/DateUtil";
import { Vue, Component, Prop, Watch } from "division-marker";
@Component({ components: {}, mixins: [] })
export default class AppStudent extends Vue {
  transitionName = "slide-prev";
  date = DateUtil.to_yyyymmdd_ddd_slash(new Date());

  allow_navbar() {
    // return this.$route.fullPath.match(/\/study\//) || this.$route.fullPath.match(/\/branch\//)
    return [/sign_in/, /sign_up/].every(
      reg => this.$route.fullPath.match(reg) == null
    );
  }

  async sign_out() {
    const is_teacher = this.$store.getters["wt/is_teacher"];
    console.log(is_teacher);
    await this.$store.dispatch("wt/sign_out");
    if (is_teacher) {
      window.location.href = "#/admin/sign_in";
    } else {
      window.location.href = "#/sign_in";
    }
  }
}
